import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import get from 'lodash/get';
import { useSelector } from 'react-redux';
import getImageUrl from '@configuratorware/configurator-frontendgui/App/Utils/getImageUrl';

const useStyles = makeStyles(
  (theme) => ({
    headerLogoContainer: {
      height: 64,
      position: 'absolute',
      top: 0,
      display:'flex',
      alignItems: 'center',
      transform: 'translateX(-50%)',
      left: '50%',
    },
    headerLogo: {
      [theme.breakpoints.down('xs')]: {
        maxWidth: 200,
        height: 'auto',
      },
      height: '100%',
   }
  }),
  {
    name: 'HeaderLogo',
  }
);

export const HeaderLogo = () => {
  const classes = useStyles();
  const {client} = useSelector(state => state.configurator);
 
  return (
    <div className={classes.headerLogoContainer}>
      <img className={classes.headerLogo} src={getImageUrl(get(client, 'theme.logo', ''))} alt=""/>
    </div>
  );
};

export default HeaderLogo;
